/**
 * Sports fan starter template.
 *
 * Persona: person who wants scores front-and-center, plus market and weather glance.
 * Tile mix: sports score (2×2), news sports topic (2×1), clock (1×1), markets (2×1).
 *
 * Sports tile teamId: 133604 = Arsenal FC (TheSportsDB public API; verified via
 * https://www.thesportsdb.com/api/v1/json/3/searchteams.php?t=Arsenal on 2026-07-24).
 * The user is expected to update this to their own team via edit mode.
 */
import { BOARD_SCHEMA_VERSION, TILE_SCHEMA_VERSION } from 'briefpane/schema';

export const SPORTS_FAN_BOARD_RAW: unknown = {
  schemaVersion: BOARD_SCHEMA_VERSION,
  id: 'board_sportsfan',
  createdAt: '2026-07-24T00:00:00.000Z',
  updatedAt: '2026-07-24T00:00:00.000Z',
  grid: { cols: 8, rowHeight: 120, gap: 12 },
  layout: [
    { tileId: 'tile_sfscr1', x: 0, y: 0, w: 2, h: 2 },
    { tileId: 'tile_sfnws1', x: 2, y: 0, w: 2, h: 1 },
    { tileId: 'tile_sfclk1', x: 4, y: 0, w: 1, h: 1 },
    { tileId: 'tile_sfmkt1', x: 2, y: 1, w: 2, h: 1 },
  ],
  tiles: [
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_sfscr1',
      // teamId 133604 = Arsenal FC (TheSportsDB). Change to your team in edit mode.
      type: 'sports.score',
      source: {
        provider: 'thesportsdb',
        params: { league: 'epl', teamId: '133604' },
      },
      refresh: { intervalSec: 60 },
      display: { size: '2x2', variant: 'big-number' },
      glance: { primary: 'score', delta: 'status', state: 'result' },
      label: 'Arsenal',
    },
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_sfnws1',
      type: 'news.headlines',
      source: { provider: 'gnews', params: { topic: 'sports', count: 4 } },
      refresh: { intervalSec: 600 },
      display: { size: '2x1', variant: 'headline' },
      glance: { primary: 'headline', delta: 'source', state: null },
      label: 'Sports News',
    },
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_sfclk1',
      type: 'clock.local',
      source: { provider: 'local', params: { tz: 'America/New_York', format: '12h' } },
      display: { size: '1x1', variant: 'big-number' },
      glance: { primary: 'time', delta: 'date', state: null },
      label: 'Clock',
    },
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_sfmkt1',
      type: 'markets.quote',
      source: {
        provider: 'finnhub',
        params: { symbols: ['SPY'], display: 'change' },
      },
      refresh: { intervalSec: 60 },
      display: { size: '2x1', variant: 'big-number' },
      glance: { primary: 'price', delta: 'changePct', state: 'direction' },
      label: 'Markets',
    },
  ],
};
